import { render, staticRenderFns } from "./setChartConf-editor.vue?vue&type=template&id=173e1f48&scoped=true"
import script from "./setChartConf-editor.vue?vue&type=script&lang=js"
export * from "./setChartConf-editor.vue?vue&type=script&lang=js"
import style0 from "./setChartConf-editor.vue?vue&type=style&index=0&id=173e1f48&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173e1f48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('173e1f48')) {
      api.createRecord('173e1f48', component.options)
    } else {
      api.reload('173e1f48', component.options)
    }
    module.hot.accept("./setChartConf-editor.vue?vue&type=template&id=173e1f48&scoped=true", function () {
      api.rerender('173e1f48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/dashboard-design/charts/property-editor/setChartConf-editor.vue"
export default component.exports